import { ChevronDownIcon } from '@c2fo/liquidity/icons';
import { formatThreadDate } from '../insightsUtils';
import type { ThreadSummary } from '../InsightsPage.types';

interface InsightsSidebarProps {
  isSidebarOpen: boolean;
  isLoadingHistory: boolean;
  threadHistory: ThreadSummary[];
  activeThreadId: string | null;
  onToggleSidebar: () => void;
  onNewChat: () => void;
  onSelectThread: (threadId: string) => void;
}

export const InsightsSidebar = ({
  isSidebarOpen,
  isLoadingHistory,
  threadHistory,
  activeThreadId,
  onToggleSidebar,
  onNewChat,
  onSelectThread,
}: InsightsSidebarProps) => {
  return (
    <div
      className="insights-sidebar"
      id="insights-sidebar"
      data-testid="insights-sidebar"
      data-collapsed={!isSidebarOpen}
    >
      <div className="sidebar-header">
        <h2>Conversations</h2>
        <div className="sidebar-header-actions">
          <button
            type="button"
            className="sidebar-collapse-button"
            onClick={onToggleSidebar}
            aria-label={isSidebarOpen ? 'Collapse conversations sidebar' : 'Expand conversations sidebar'}
            aria-controls="insights-sidebar"
            aria-expanded={isSidebarOpen}
            data-testid="insights-sidebar-toggle"
          >
            <ChevronDownIcon className="sidebar-toggle-icon" />
          </button>
          <button type="button" onClick={onNewChat} className="btn-new-chat">
            <span className="btn-new-chat-icon" aria-hidden="true">
              +
            </span>
            <span className="btn-new-chat-text">New</span>
          </button>
        </div>
      </div>

      <div className="sidebar-threads">
        {isLoadingHistory && threadHistory.length === 0 && <div className="sidebar-loading">Loading...</div>}
        {!isLoadingHistory && threadHistory.length === 0 && <div className="sidebar-empty">No conversations yet</div>}

        {threadHistory.map((threadSummary) => (
          <button
            key={threadSummary.threadId}
            type="button"
            className={`sidebar-thread-item ${threadSummary.threadId === activeThreadId ? 'active' : ''}`}
            onClick={() => onSelectThread(threadSummary.threadId)}
          >
            <span className="thread-title">{threadSummary.title ?? 'New conversation'}</span>
            <span className="thread-date">{formatThreadDate(threadSummary.createdAt)}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
